import firebase from 'firebase/app'
import 'firebase/auth';
import 'firebase/firestore'
import 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyBaKMuhuJ9FwQrCqC9Tvq7Pf3b6DFSZDDU",
    authDomain: "kirei2020-e78d2.firebaseapp.com",
    databaseURL: "https://kirei2020-e78d2.firebaseio.com",
    projectId: "kirei2020-e78d2",
    storageBucket: "kirei2020-e78d2.appspot.com",
    messagingSenderId: "242635491866",
    appId: "1:242635491866:web:7870953fc46b0e9c489fa3",
    measurementId: "G-D44LLWR4YF"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)


firebase.firestore().settings({ experimentalForceLongPolling: true });

const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();


export {db, auth, storage};
